import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHead, Card } from "@/admin/ui";

const ReturnsAdmin = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/returns").then((r) => setRows(r.data)).catch(() => {}); }, []);

  const mailto = (r) => {
    const subject = encodeURIComponent(`Your NoirbyAmara return${r.order_number ? ` — ${r.order_number}` : ""}`);
    const body = encodeURIComponent(
      `Hi${r.name ? " " + r.name : ""},\n\nThank you for your return request${r.order_number ? ` for order ${r.order_number}` : ""}. ` +
      `Please send the item(s), unworn with tags attached and in their original condition, to:\n\n[RETURN ADDRESS]\n\n` +
      `Once we receive and inspect them, we'll process your refund or exchange.\n\nWith care,\nNOIRBYAMARA`);
    return `mailto:${r.email}?subject=${subject}&body=${body}`;
  };

  return (
    <div data-testid="returns-admin">
      <PageHead title="Returns" sub="Requests to return or exchange." />
      {rows.length === 0 && <p className="text-espresso/50" data-testid="returns-empty">No return requests yet.</p>}
      <div className="space-y-3">
        {rows.map((r) => (
          <Card key={r.id} className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            <div data-testid={`return-${r.id}`}>
              <p className="font-serif text-lg">{r.order_number || "No order number"}</p>
              <p className="text-sm text-espresso/70">{r.name ? `${r.name} · ` : ""}{r.email}</p>
              {r.message && <p className="text-sm text-espresso/50 mt-1 whitespace-pre-line">{r.message}</p>}
              <p className="text-[0.62rem] tracking-[0.14em] uppercase text-espresso/40 mt-2">{r.at ? new Date(r.at).toLocaleString() : ""}</p>
            </div>
            <a href={mailto(r)} data-testid={`return-reply-${r.id}`}
              className="shrink-0 bg-espresso text-cream px-5 py-2.5 text-[0.66rem] tracking-[0.16em] uppercase hover:bg-cocoa transition-colors text-center">
              Reply with address
            </a>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ReturnsAdmin;
